require('./account-form.directive');
require('./banner-form.directive');
require('./fi-form.directive');
require('./training-resource-form.directive');
require('./user-form.directive');
